import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { IMG } from "@/data/content";

export default function PizzaFeature() {
  return (
    <section data-testid="pizza-feature" className="relative section-pad overflow-hidden">
      <div className="absolute inset-0">
        <img src={IMG.pizzaDough} alt="Blat pizza întins manual" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0b0b0f]/95 via-[#0b0b0f]/80 to-[#0b0b0f]/30" />
      </div>
      <div className="relative max-w-7xl mx-auto container-px text-white">
        <div className="max-w-2xl">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="eyebrow text-gold"
          >
            Blatul care face diferența
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="h-display mt-5 text-4xl md:text-6xl text-white"
          >
            Blatul bun se simte <br />
            <em className="text-gold not-italic shimmer-text">înainte de prima mușcătură.</em>
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="mt-6 text-base md:text-lg text-white/85 leading-relaxed"
          >
            Un blat de pizza bun trebuie să fie elastic, echilibrat, ușor de lucrat și gustos după coacere. Pentru pizzerii,
            fast-food-uri și restaurante, blatul nu este un detaliu. Este fundația produsului.
          </motion.p>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3 }}
            className="mt-4 font-display italic text-xl md:text-2xl text-gold-soft"
          >
            &bdquo;Un blat bun nu ține doar toppingul. Ține reputația localului tău.&rdquo;
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.4 }}
            className="mt-9 flex flex-col sm:flex-row gap-3"
          >
            <Link to="/contact" data-testid="pizza-cta-link">
              <Button className="btn-gold rounded-full h-12 px-7" data-testid="pizza-cta">
                Cere ofertă pentru blat pizza
              </Button>
            </Link>
            <Link to="/blat-pizza">
              <Button variant="outline" className="rounded-full h-12 px-7 border-white/30 text-white bg-white/5 hover:border-gold hover:text-gold">
                Vezi pagina blat pizza
              </Button>
            </Link>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
